module.exports = __webpack_public_path__ + "images/landing/banner/help-img-4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-4.png
// module id = ukZe
// module chunks = 154